/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NeptuneApiToken
 */
export interface NeptuneApiToken {
    /**
     * 
     * @type {string}
     * @memberof NeptuneApiToken
     */
    token: string;
}

/**
 * Check if a given object implements the NeptuneApiToken interface.
 */
export function instanceOfNeptuneApiToken(value: object): value is NeptuneApiToken {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function NeptuneApiTokenFromJSON(json: any): NeptuneApiToken {
    return NeptuneApiTokenFromJSONTyped(json, false);
}

export function NeptuneApiTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): NeptuneApiToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function NeptuneApiTokenToJSON(value?: NeptuneApiToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

